export function makeAvatarName(fullName: string): string {
  if (typeof fullName === "string") {
    const parts = fullName.split(" ");
    if (parts.length > 3) {
      return parts.slice(0,3).join(" ");
    }
  }
  return fullName;
}